import type { Meta, StoryFn } from '@storybook/react';

import { OpenGraphPreview } from '@pega/cosmos-react-social';
import { Link } from '@pega/cosmos-react-core';

import {
  errorResponse,
  transformedMockResponse,
  transformedMockResponseBrokenImage
} from './OpenGraphPreview.mocks';

export default {
  title: 'Social/OpenGraphPreview',
  component: OpenGraphPreview
} as Meta;

interface OpenGraphPreviewStoryArgs {
  brokenImage: boolean;
  error: boolean;
}

export const OpenGraphPreviewDemo: StoryFn<OpenGraphPreviewStoryArgs> = (
  args: OpenGraphPreviewStoryArgs
) => {
  const response = args.brokenImage ? transformedMockResponseBrokenImage : transformedMockResponse;

  if (args.error) {
    return (
      <>
        <Link href='https://www.pega.com'>https://pega.com</Link>;
        <OpenGraphPreview data={errorResponse} />
      </>
    );
  }

  return (
    <>
      <Link href='https://www.pega.com'>https://pega.com</Link>
      <OpenGraphPreview data={response} />
    </>
  );
};

OpenGraphPreviewDemo.args = {
  brokenImage: false
};

OpenGraphPreviewDemo.argTypes = {
  brokenImage: { control: { type: 'boolean' } }
};
